<template>
  <v-container class="checkout-page">
    <div class="checkout-top">
      <h1 class="checkout-title">Checkout</h1>
      <p class="checkout-subtitle">Completá los datos para confirmar tu pedido</p>
    </div>

    <v-stepper
      v-model="pasoActual"
      :vertical="$isMobile()"
      v-if="$isMobile()"
      color="primary"
      class="checkout-stepper"
      flat
    >
      <template v-for="(paso,n) in pasos">
        <v-stepper-header :key="`step_header_${n}`">
          <v-stepper-step
            :complete="pasoCompletado(n+1)"
            :step="n+1"
            :rules="[value => !!paso.validado]"
            :color="estado(n+1)"
          >
            {{ paso.nombre }}
          </v-stepper-step>
        </v-stepper-header>
        <v-stepper-content :step="n+1" :key="`step_content_${n}`">
          <v-form :ref="'stepForm'" v-model="paso.validado" lazy-validation>
            <component
              :is="paso.componente"
              @importeMinimoChange="validarImporteMinimo"
              @compra-cancelada="errorCompra"
              @pedido-grabado="compraFinalizada"
            />
          </v-form>
          <div class="checkout-actions">
            <v-btn
              v-if="pasoActual === 1"
              class="checkout-btn-secondary"
              color="primary"
              outlined
              @click.prevent="seguirComprando"
            >
              Seguir comprando
            </v-btn>
            <v-btn
              v-if="pasoActual != 1"
              class="checkout-btn-secondary"
              color="primary"
              outlined
              :disabled="comprando"
              @click.prevent="pasoActual = n"
            >
              Volver
            </v-btn>
            <v-btn
              v-if="n+1 < ultimoPaso"
              class="checkout-btn-primary"
              color="primary"
              dark
              :disabled="(!paso.validado || importeInvalido)"
              @click.prevent="validarPaso(n)"
            >
              Siguiente
            </v-btn>
            <v-btn
              v-else
              class="checkout-btn-primary"
              color="primary"
              dark
              :loading="comprando"
              :disabled="comprando || importeInvalido"
              @click.stop.prevent="confirmarCompra"
            >
              Confirmar
            </v-btn>
          </div>
        </v-stepper-content>
      </template>
    </v-stepper>

    <v-stepper v-model="pasoActual" color="primary" class="checkout-stepper" flat v-else>
      <v-stepper-header>
        <v-stepper-step :step="1" color="primary">
          Datos para terminar tu pedido
        </v-stepper-step>
        <v-stepper-step :step="2" color="primary">
          Último paso para confirmar
        </v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content :step="1">
          <v-form :ref="'stepForm'" v-model="pasos[0].validado" lazy-validation>
            <v-row>
              <v-col cols="6">
                <component
                  :is="pasos[0].componente"
                  @importeMinimoChange="validarImporteMinimo"
                  :tarjetaPlana="false"
                />
              </v-col>
              <v-col cols="6">
                <component :is="pasos[1].componente" :tarjetaPlana="false" />
                <div class="checkout-actions">
                  <v-btn
                    class="checkout-btn-secondary"
                    color="primary"
                    outlined
                    @click.prevent="seguirComprando"
                  >
                    Seguir comprando
                  </v-btn>
                  <v-btn
                    class="checkout-btn-primary"
                    color="primary"
                    dark
                    :disabled="(!pasos[0].validado || importeInvalido)"
                    @click.prevent="validarPaso(0)"
                  >
                    Siguiente
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-stepper-content>
        <v-stepper-content :step="2">
          <component
            :is="pasos[2].componente"
            @importeMinimoChange="validarImporteMinimo"
            @compra-cancelada="errorCompra"
            @pedido-grabado="compraFinalizada"
          />
          <div class="checkout-actions">
            <v-btn
              v-if="pasoActual != 1"
              class="checkout-btn-secondary"
              color="primary"
              outlined
              :disabled="comprando"
              @click.prevent="pasoActual = pasoActual - 1"
            >
              Volver
            </v-btn>
            <v-btn
              class="checkout-btn-primary"
              color="primary"
              dark
              :loading="comprando"
              :disabled="comprando || importeInvalido"
              @click.stop.prevent="confirmarCompra"
            >
              Confirmar
            </v-btn>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'
import DatosPersonales from '../components/checkout/DatosPersonales.vue'
import FormasPagoEntrega from '../components/checkout/FormasPagoEntrega.vue'
import Resumen from '../components/checkout/Resumen.vue'
import { bus } from '@/helpers/bus.js'

export default {
  name: 'Checkout',
  components: {
    DatosPersonales,
    FormasPagoEntrega,
    Resumen
  },
  beforeDestroy () {
    this.resetHorarioProgramado()
  },
  methods: {
    ...mapActions('Carrito', ['resetCarrito']),
    ...mapMutations('Checkout', ['resetHorarioProgramado']),
    validarPaso (n) {
      this.pasos[n].validado = false
      const validado = this.$refs.stepForm[n] === undefined ? this.$refs.stepForm.validate() : this.$refs.stepForm[n].validate()
      if (validado) {
        this.pasos[n].validado = true
        this.pasoActual = n + 2
      }
    },
    pasoCompletado (paso) {
      return this.pasoActual > paso
    },
    estado (paso) {
      return this.pasoActual > paso ? 'green' : 'primary'
    },
    confirmarCompra () {
      this.comprando = true
      setTimeout(() => {
        bus.$emit('compraConfirmada')
      }, 2000)
    },
    errorCompra (data) {
      this.comprando = false
      if (!data.success) this.$emit('showAlert', data)
    },
    compraFinalizada (data) {
      this.comprando = false
      localStorage.setItem('mis-pedidos', JSON.stringify([parseInt(data)]))
      this.resetCarrito()
      this.$router.push({
        name: 'VerPedido',
        params: {
          id: parseInt(data)
        }
      })
    },
    validarImporteMinimo (noValido) {
      this.importeInvalido = noValido
    },
    seguirComprando () {
      const client = this.$route.params.client || this.$clientCode()
      this.$router.push({ name: 'Home', params: { client } }).catch(() => {})
    }
  },
  data () {
    return {
      pasos: [{
        nombre: 'Elegir forma de entrega y de pago',
        validado: false,
        componente: 'FormasPagoEntrega'
      },
      {
        nombre: 'Completar datos personales',
        validado: false,
        componente: 'DatosPersonales'
      },
      {
        nombre: 'Resumen de tu pedido',
        validado: false,
        componente: 'Resumen'
      }],
      ultimoPaso: 3,
      pasoActual: 1,
      comprando: false,
      importeInvalido: false
    }
  }
}
</script>

<style scoped>
.checkout-page {
  max-width: 1100px;
  padding-bottom: 32px;
}
.checkout-top {
  margin-bottom: 16px;
  text-align: left;
}
.checkout-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 800;
  color: rgba(0, 0, 0, 0.87);
}
.checkout-subtitle {
  margin: 4px 0 0;
  color: rgba(0, 0, 0, 0.55);
  font-size: 0.95rem;
}
.checkout-stepper {
  background: #fff !important;
  border: 1px solid #ececec;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}
.checkout-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 16px;
}
.checkout-btn-primary,
.checkout-btn-secondary {
  min-width: 140px;
  height: 44px !important;
  border-radius: 12px !important;
  text-transform: none !important;
  letter-spacing: 0.02em !important;
  font-weight: 700 !important;
}
.checkout-btn-secondary {
  background: #fff !important;
}
.checkout-btn-primary {
  color: #fff !important;
}
</style>
